import { ElementType } from 'react';
import { Element, ElementProps } from '../element';

export const Column = <T extends ElementType = 'div'>({
  ...props
}: ElementProps<T>) => {
  return <Element display="flex" flexDirection="column" {...props} />;
};
